import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../../common/global-constants";
import { BOItem } from "../../models/BOItem.model";
import { BOOdontologyPatientBackground } from "../../models/odo/BOOdontologyPatientBackground.model";

@Injectable({
  providedIn: 'root'
}

)
export class OdontologyPatientBackground{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/OdontologyPatientBackground';

    constructor(private http:HttpClient){}

// #region First

    getAll():Observable<BOOdontologyPatientBackground[]>{
        return this.http.get<BOOdontologyPatientBackground[]>(this.myAppUrl + this.myApiUrl);
    }


    saveOrUpdateOdontologyPatientBackgrounds(backgrounds:BOOdontologyPatientBackground[]):Observable<BOOdontologyPatientBackground[]>
    {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
        }
        const body=JSON.stringify(backgrounds);
        return this.http.post<BOOdontologyPatientBackground[]>(this.myAppUrl + this.myApiUrl + '/saveOrUpdateOdontologyPatientBackgrounds',body,httpOptions);
    }


    getOdontologyHistoriesByClinicId(clinicHistoryId:number):Observable<BOOdontologyPatientBackground[]>{
        return this.http.get<BOOdontologyPatientBackground[]>(this.myAppUrl + this.myApiUrl + '/getOdontologyHistoriesByClinicId/' + clinicHistoryId);
    }

    getAllByPatientId(patientId:number):Observable<BOOdontologyPatientBackground[]>{
        return this.http.get<BOOdontologyPatientBackground[]>(this.myAppUrl + this.myApiUrl+'/getAllByPatientId/'+patientId);
    }
// #endregion First


//#region Single
  createOrUpdateOdontologyPatientBackgroundSingle(patientId:number, disease:BOOdontologyPatientBackground):Observable<BOOdontologyPatientBackground>
  {
    const httpOptions = {
        headers: new HttpHeaders({'Content-Type': 'application/json'})
      }
      const body=JSON.stringify(disease);
      return this.http.post<BOOdontologyPatientBackground>(this.myAppUrl + this.myApiUrl + '/createOrUpdateOdontologyPatientBackgroundSingle/' + patientId,body,httpOptions);
  }

  deleteOdontologyPatientBackgroundSingle(id:number):Observable<BOOdontologyPatientBackground>
  {
        const httpOptions = {
            headers: new HttpHeaders({'Content-Type': 'application/json'})
          }
          return this.http.post<BOOdontologyPatientBackground>(this.myAppUrl + this.myApiUrl + '/deleteOdontologyPatientBackgroundSingle/' + id,null,httpOptions);
  }


//#endregion Single



}
